<template>
  <div class="pa-3 pt-2">
    <v-row>
      <v-col cols="12">
        <v-btn color="secondary" v-if="buttonShow('create')" @click="createModalDialog = true">Create new</v-btn>
        <!-- <v-btn color="warning" v-if="campaignStatus === -1 && isNotClientRole && !isArchive" @click="openReportPasscodeDialog('details')"><v-icon small>download</v-icon> Creator Statistics Report</v-btn>
        <v-btn color="warning" v-if="campaignStatus === -1 && isNotClientRole && !isArchive" @click="openReportPasscodeDialog('all')"><v-icon color="white" small>download</v-icon> Cost & Period Report</v-btn>
        <v-btn color="warning" v-if="campaignStatus === -1 && isNotClientRole && !isArchive" @click="openReportPasscodeDialog('pairings')"><v-icon color="white" small>download</v-icon> Creator Payout Report</v-btn> -->

        <v-menu offset-y v-if="campaignStatus === -1 && isNotClientRole && !isArchive">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon small>download</v-icon> Creator Statistics Report
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openReportPasscodeDialog('details', 'excel')">
              <v-list-item-title>Excel</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('details', 'csv')">
              <v-list-item-title>CSV</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('details', 'sync')">
              <v-list-item-title>Sync Data</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="campaignStatus === -1 && isNotClientRole && !isArchive">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon small>download</v-icon> Cost & Period Report
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openReportPasscodeDialog('all', 'excel')">
              <v-list-item-title>Excel</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('all', 'csv')">
              <v-list-item-title>CSV</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('all', 'sync')">
              <v-list-item-title>Sync Data</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="campaignStatus === -1 && isNotClientRole && !isArchive">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon small>download</v-icon> Creator Payout Report
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openReportPasscodeDialog('pairings', 'excel')">
              <v-list-item-title>Excel</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('pairings', 'csv')">
              <v-list-item-title>CSV</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('pairings', 'sync')">
              <v-list-item-title>Sync Data</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="campaignStatus === -1 && isNotClientRole && !isArchive">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon small>download</v-icon> Campaign Performance Report
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openReportPasscodeDialog('performance', 'excel')">
              <v-list-item-title>Excel</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('performance', 'csv')">
              <v-list-item-title>CSV</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openReportPasscodeDialog('performance', 'sync')">
              <v-list-item-title>Sync Data</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Reload button -->
        <v-btn color="secondary" icon @click.stop="paginate(1)">
          <i class="fa fa-repeat"></i>
        </v-btn>
        <v-btn @click="resetFilter" class="ml-2"  style="float: right" v-if="buttonShow('create')">Reset Filters</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <v-row class="filter-area" v-if="isNotClientRole">
            <!-- <v-col cols="12" sm="12" md="3" lg="3">
              <v-autocomplete
                :items="allClients"
                item-value="id"
                item-text="name"
                label="Client"
                v-model="selectedFilter.client"
                outlined
                @change="searchFilter"
              ></v-autocomplete>
            </v-col> -->
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="campaignTypeDisplayFilter"
                item-value="value"
                item-text="text"
                label="Type"
                v-model="selectedFilter.campaignType"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="campaignVerticals"
                item-value="id"
                item-text="name"
                label="Campaign Verticals"
                v-model="selectedFilter.vertical"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="countries"
                item-value="code"
                item-text="name"
                label="Target Location"
                v-model="selectedFilter.targetLocation"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="AM"
                item-value="id"
                item-text="name"
                label="AM"
                v-model="selectedFilter.AM"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="CO"
                item-value="id"
                item-text="name"
                label="CC"
                v-model="selectedFilter.CO"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="1" lg="1" v-if="campaignStatus === -1">
              <v-autocomplete
                :items="campaignStageDisplay"
                label="Stage"
                v-model="selectedFilter.stage"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="1" lg="1" v-if="campaignStatus === -1">
              <v-autocomplete
                :items="verifiedFilters"
                label="Verified Payouts"
                v-model="selectedFilter.verified"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="campaignStatus === -1">
            <v-col cols="12" sm="12" md="2" lg="2" v-if="campaignStatus === -1">
              <v-menu
                ref="startMonthPicker"
                v-model="startMonthPicker"
                :close-on-content-click="false"
                :return-value.sync="selectedStartMonth"
                transition="scale-transition"
                offset-y
                dense
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Start Month"
                    v-model="selectedFilter.searchStartMonth"
                    readonly
                    clearable
                    outlined
                    dense
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                    @change="searchFilter"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilter.searchStartMonth"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="secondary"
                      @click="startMonthPicker = false"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="secondary"
                      @click="searchStartMonthOk"
                  >
                      OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2" v-if="campaignStatus === -1">
              <v-menu
                ref="endMonthPicker"
                v-model="endMonthPicker"
                :close-on-content-click="false"
                :return-value.sync="selectedEndMonth"
                transition="scale-transition"
                dense
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="End Month"
                    v-model="selectedFilter.searchLastMonth"
                    readonly
                    clearable
                    outlined
                    dense
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                    @change="searchFilter"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilter.searchLastMonth"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="secondary"
                      @click="endMonthPicker = false"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="secondary"
                      @click="searchEndMonthOk"
                  >
                      OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12" md="2" lg="2" style="min-width: 160px;">
              <v-checkbox
                class="filter-checkbox mt-1"
                style="max-width:200px;"
                v-model="selectedFilter.htmlReport"
                label="HTML Reports"
                color="secondary"
                :value="false"
                hide-details
                @change="searchFilter()"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" md="2" lg="2" style="min-width: 160px;" v-if="!isArchive">
              <v-checkbox
                class="filter-checkbox mt-1"
                style="max-width:150px;"
                v-model="selectedFilter.archive"
                label="Load Archive"
                color="secondary"
                :value="false"
                hide-details
                @change="paginate(1)"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="isNotClientRole" justify="end" style="width:100%">
            <v-col cols="12" sm="8" md="8" lg="8" v-if="!isArchive">
              <v-toolbar class="bulk-action float-left transparent" flat>
                <v-menu offset-y v-if="selectedCampaigns.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" v-on="on">Bulk Action</v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(menuItem, i) in tableActions"
                      :key="i"
                      @click="performSelected(menuItem.action)"
                    >
                      <v-list-item-content>
                        <div>
                          <v-icon>mdi-{{menuItem.icon}}</v-icon> {{menuItem.name}}
                        </div>
                      </v-list-item-content>
                      <!-- <v-list-tile-action>
                        <v-icon>mdi-{{menuItem.icon}}</v-icon>
                      </v-list-tile-action> -->
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-col>
            <v-col cols="12" sm="8" md="8" lg="8" v-if="isArchive">
              <v-btn
              color="success"
              class="mt-3"
              small
              v-if="selectedCampaigns.length > 0"
              @click="restoreArchive">
                <v-icon small>mdi-restore</v-icon> Restore
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4">
              <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-spacer v-if="!isNotClientRole"></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details v-if="!isNotClientRole"></v-text-field>
        </div>
        <!-- BEGIN all campaigns table -->
        <div class="text-right" style="margin-top:-25px;">
          <v-menu
            :close-on-content-click="false"
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                v-bind="attrs"
                v-on="on"
                @click="openColSettingsModal"
              >
                <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
              </v-btn>
            </template>
          </v-menu>
          <v-btn
            icon
            color="secondary"
            :aria-pressed="String(showActionsColumn)"
            :title="showActionsColumn ? 'Hide Actions column' : 'Show Actions column'"
            :aria-label="showActionsColumn ? 'Hide Actions column' : 'Show Actions column'"
            @click="showActionsColumn = !showActionsColumn"
          >
            <v-icon>{{ showActionsColumn ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="computedAllCampaignHeaders"
          :search="filter"
          :items="filteredItems"
          class="ims-sticky-actions-table table-small elevation-1"
          :class="{ 'actions-column-visible': showActionsColumn }"
          v-if="campaignStatus === -1 && isNotClientRole"
          show-select
          @toggle-select-all="selectAllCampaigns"
          :single-select="false"
          v-model="selectedCampaigns"
          :loading="loading">
          <!-- <template v-slot:items="props">
            <td class="text-xs-left">
              {{ props.item.name }}
              <v-chip
              color="warning"
              x-small
              text-color="white"
              v-if="props.item.markupCOGS">
                Markup COGS
              </v-chip>
            </td>
            <td class="text-xs-left" v-if="Array.isArray(props.item.goal)">
              <v-chip v-for="value in props.item.goal" :key="value">{{ value }}</v-chip>
            </td>
            <td class="text-xs-left" v-else>{{ props.item.goal }}</td>
            <td class="text-xs-left">{{ props.item.updatedAtDisplay }}</td>
            <td class="text-xs-left">{{ props.item.clientName }}</td>
          </template> -->
          <template v-slot:[`item.name`]="{ item }">
            <td class="text-xs-left">
              {{ item.name }}
              <v-chip
              x-small
              v-if="item.archive">
                Archived
              </v-chip>
              <div v-else>
                <div v-if="item.lockedCOGS">
                  <v-chip
                  color="red"
                  x-small
                  text-color="white">
                    <v-icon small>mdi-lock</v-icon> Locked COGS
                  </v-chip>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.campaignType`]="{ item }">
            <td class="text-xs-left">{{item.campaignType}}</td>
          </template>
          <template v-slot:[`item.countryDisplay`]="{ item }">
            <td class="text-xs-left">{{item.countryDisplay}}</td>
          </template>
          <template v-slot:[`item.vertical`]="{ item }">
            <td class="text-xs-left">
              <v-chip
                small
                v-for="(i, index) in item.vertical"
                :key="index"
                class="ma-1"
              >
                {{i.name}}
              </v-chip>
            </td>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            <td class="text-xs-left">
              ${{item.budget | thousandSeprator}}
              <v-chip
              color="warning"
              x-small
              text-color="white"
              v-if="isNotClientRole && item.markupCOGS">
                Markup COGS
              </v-chip>
            </td>
          </template>
          <!-- <template v-slot:[`item.revenueRecognized`]="{ item }">
            <td class="text-center">${{formatDecimal(item.revenueRecognized)  | thousandSeprator}}</td>
          </template>
          <template v-slot:[`item.unrecognizedRevenue`]="{ item }">
            <td class="text-center">${{formatDecimal(item.unrecognizedRevenue) | thousandSeprator}}</td>
          </template> -->
          <template v-slot:[`item.target`]="{ item }">
            <td class="text-center">
              <span v-if="item.target">${{item.target | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.cogs`]="{ item }">
            <td class="text-center">
              <span v-if="item.cogs">
                ${{item.cogs | thousandSeprator}}
                <v-chip
                color="red"
                x-small
                text-color="white"
                v-if="item.cogs && item.target && item.cogs > item.target">
                  Burst COGS
                </v-chip>
              </span>
            </td>
          </template>
          <template v-slot:[`item.cogsPercentage`]="{ item }">
            <td class="text-center">
              <span v-if="item.cogsPercentage">{{item.cogsPercentage}}%</span>
            </td>
          </template>
          <template v-slot:[`item.campaignPeriod`]="{ item }">
            <td class="text-center">{{item.campaignPeriod || ''}}</td>
          </template>
          <template v-slot:[`item.startMonth`]="{ item }">
            <td class="text-center">{{item.startMonth ? formatMonth(item.startMonth) : ''}}</td>
          </template>
          <template v-slot:[`item.endMonth`]="{ item }">
            <td class="text-center">{{item.endMonth ? formatMonth(item.endMonth) : ''}}</td>
          </template>
          <template v-slot:[`item.firstPostDate`]="{ item }">
            <td class="text-center">{{item.firstPostDate || ''}}</td>
          </template>
          <template v-slot:[`item.lastPostDate`]="{ item }">
            <td class="text-center">{{item.lastPostDate || ''}}</td>
          </template>
          <template v-slot:[`item.payoutStatus`]="{ item }">
            <td class="text-center">
              <div>
                <v-chip v-if="item.payoutStatus && item.payoutStatus === payoutStatus.CONFIRMED"
                class="cursor-pointer" color="green" outlined small target="_blank" :to="'/finance/payment-consolidation/status?id='+item.id">
                    {{item.payoutStatusDisplay}}
                </v-chip>
                  <v-chip v-else
                  class="cursor-pointer" color="secondary" outlined small target="_blank" :to="'/finance/payment-consolidation/status?id='+item.id">
                    {{item.payoutStatusDisplay}}
                  </v-chip>
              </div>
            </td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="text-center" style="min-width:230px;">
              <!-- Campaign Report Button -->
              <v-btn v-if="isNotClientRole && item.status >= campaignStatuses.ONGOING" :to="'/campaign-report-internal?id='+item.id" target="_blank" color="secondary" class="ims-action" title="View Campaign Report Internal" data-toggle="tooltip" data-placement="top" aria-label="View Campaign Report Internal">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
              <!-- Campaign HTML Report Button -->
              <v-btn v-if="isNotClientRole && item.status >= campaignStatuses.ONGOING" :to="'/reports/campaign/summary?id='+item.id" target="_blank" class="ims-action ims-btn-third" aria-label="View Campaign HTML Report" title="View Campaign HTML Report" data-toggle="tooltip" data-placement="top">
                <v-icon small>mdi-web</v-icon>
              </v-btn>
              <!-- Manage Permissions Button -->
              <v-btn @click="changeSettings(item)" color="secondary" class="ims-action" data-toggle="tooltip" data-placement="top" title="Change Setting" aria-label="Change Setting">
                <i class="fas fa-sliders-h"></i>
              </v-btn>
              <!-- Delete Button -->
              <v-btn
                data-toggle="tooltip"
                data-placement="top"
                title="Delete Campaign"
                @click="deleteCampaign(item.id)"
                color="error"
                class="ims-action"
                aria-label="Delete Campaign"
              >
                <v-icon small >delete</v-icon>
              </v-btn>
              <!-- Edit Button -->
              <v-btn @click="getCampaignDataToEdit(item.id)" color="info" class="ims-action" data-toggle="tooltip" data-placement="top" title="Edit Campaign" aria-label="Edit Campaign">
                <v-icon color="white" small>edit</v-icon>
              </v-btn>
              <!-- View Button -->
              <v-btn @click="getCampaignDataToView(item.id)" color="info" class="ims-action" data-toggle="tooltip" data-placement="top" title="View Campaign" aria-label="View Campaign">
                <v-icon color="white" small>remove_red_eye</v-icon>
              </v-btn>
              <!-- Activate/Deactivate the campaign after client made payment -->
              <v-btn
                v-show="item.activated == 0 || item.activated == undefined"
                data-toggle="tooltip"
                data-placement="top"
                title="Release to Client"
                @click="showAMCCInputsDialog(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>work</v-icon>
              </v-btn>
              <v-btn
                v-show="item.activated == 1"
                data-toggle="tooltip"
                data-placement="top"
                title="Deactivate Campaign"
                @click="activateCampaign(item.id, campaignActivationStatusConfig.DEACTIVATED)"
                color="error"
                class="ims-action"
              >
                <v-icon color="white" small>work_off</v-icon>
              </v-btn>
              <!-- Influencer Pairing "View" Button -->
              <v-btn @click="viewInfluencerPairingModal(item)" color="primary" class="ims-action" title="View Pairing Influencers" aria-label="View Pairing Influencers">
                <v-icon color="secondary" small data-toggle="tooltip" data-placement="top" title="View Pairing Influencers"
                  >mdi-account-convert</v-icon
                >
              </v-btn>
              <!-- Influencer Elimination Button by Client -->
              <v-btn
                color="primary"
                class="ims-action"
                title="View Pairing Influencers"
                aria-label="View Pairing Influencers"
                :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
                @click="startEliminate(item.id)"
              >
                <i class="fas fa-users-cog secondary--text" data-toggle="tooltip" data-placement="top" title="View Pairing Influencers"></i>
              </v-btn>
              <!-- View Brand Fact Sheet "Accept" Button -->
              <v-btn
                v-if="buttonShowBrandSheet(item)"
                data-toggle="tooltip"
                data-placement="top"
                title="View Brand Fact Sheet"
                @click="openBrandSheetModalDialog(item)"
                color="success"
                class="ims-action"
              >
                <v-icon small>mdi-file-document</v-icon>
              </v-btn>
              <!-- Pairing Brief "View" Button -->
              <v-btn
                v-if="buttonShow('pairingBrief')"
                data-toggle="modal"
                :data-target="viewPairingBriefModalIdDisplay"
                @click="getCampaignDataToView(item.id)"
                color="info"
                class="ims-action"
                title="View Pairing Brief"
                aria-label="View Pairing Brief"
              >
                <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="View Pairing Brief">pageview</v-icon>
              </v-btn>
              <!-- Pairing Brief "Accept" Button -->
              <v-btn
                v-if="buttonShow('pairingBrief')"
                data-toggle="tooltip"
                data-placement="top"
                title="Accept Pairing Brief"
                @click="approveCampaign(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <v-btn
                @click="getPairedInfluencers(item)"
                color="success"
                class="ims-action"
                v-if="showConfirmPayout"
                data-toggle="tooltip" data-placement="top" title="View Influencers"
              >
                <v-icon color="white" small>people</v-icon>
                <v-badge color="error" :content="getSubmittedCount(item)" v-if="payoutSubmittedPairings.length > 0 && getSubmittedCount(item) > 0"></v-badge>
              </v-btn>
              <v-btn
                :to="'/influencers/invoices-brief-confirmation?id='+item.id"
                target="_blank"
                color="success"
                class="ims-action"
                v-if="!showConfirmPayout"
                data-toggle="tooltip" data-placement="top" title="View Influencers"
              >
                <v-icon color="white" small>people</v-icon>
                <v-badge color="error" :content="getSubmittedCount(item)" v-if="payoutSubmittedPairings.length > 0 && getSubmittedCount(item) > 0"></v-badge>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
        <!-- End all campaigns table -->
        <!-- BEGIN vue data table -->
        <v-data-table
        :headers="computedCampaignHeaders"
        :search="filter"
        :items="filteredItems"
        class="ims-sticky-actions-table elevation-1"
        :class="{ 'actions-column-visible': showActionsColumn }"
        :show-select="isNotClientRole"
        @toggle-select-all="selectAllCampaigns"
        :single-select="false"
        v-model="selectedCampaigns"
        :key="campaignDataTableKey"
        v-else>
          <!-- <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left" v-if="Array.isArray(props.item.goal)">
              <v-chip v-for="value in props.item.goal" :key="value">{{ value }}</v-chip>
            </td>
            <td class="text-xs-left" v-else>{{ props.item.goal }}</td>
            <td class="text-xs-left">{{ props.item.updatedAtDisplay }}</td>
            <td class="text-xs-left">{{ props.item.clientName }}</td>
          </template> -->
          <template v-slot:[`item.name`]="{ item }">
            <td class="text-xs-left">
              {{ item.name }}
              <div v-if="isNotClientRole && item.lockedCOGS">
                <v-chip
                color="red"
                x-small
                text-color="white">
                  <v-icon color="white" small>mdi-lock</v-icon> Locked COGS
                </v-chip>
              </div>
            </td>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            <td class="text-xs-left">
              ${{item.budget | thousandSeprator}}
              <v-chip
              color="warning"
              x-small
              text-color="white"
              v-if="isNotClientRole && item.markupCOGS">
                Markup COGS
              </v-chip>
            </td>
          </template>
          <template v-slot:[`item.target`]="{ item }">
            <td class="text-center">
              <span v-if="item.target">${{item.target | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.cogs`]="{ item }">
            <td class="text-center">
              <span v-if="item.cogs">
                ${{item.cogs | thousandSeprator}}
                <v-chip
                color="red"
                x-small
                text-color="white"
                v-if="item.cogs && item.target && item.cogs > item.target">
                  Burst COGS
                </v-chip>
              </span>
            </td>
          </template>
          <template v-slot:[`item.cogsPercentage`]="{ item }">
            <td class="text-center">
              <span v-if="item.cogsPercentage">{{item.cogsPercentage}}%</span>
            </td>
          </template>

          <template v-slot:[`item.payoutStatus`]="{ item }">
            <td class="text-center">{{item.payoutStatus ? payoutStatusDisplay[item.payoutStatus] : ''}}</td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="justify-center">
              <!-- Campaign Report Button -->
              <v-btn v-if="isNotClientRole && item.status >= campaignStatuses.ONGOING" :to="'/campaign-report-internal?id='+item.id" target="_blank" color="secondary" class="ims-action" data-placement="top" data-toggle="tooltip" title="View Campaign Report Internal" aria-label="View Campaign Report Internal">
                <v-icon small>mdi mdi-open-in-new</v-icon>
              </v-btn>   

              <!-- Campaign HTML Report Button -->
              <v-btn v-if="isNotClientRole && item.status >= campaignStatuses.ONGOING" :to="'/reports/campaign/summary?id='+item.id" target="_blank" class="ims-action ims-btn-third" title="View Campaign HTML Report" data-toggle="tooltip" data-placement="top" aria-label="View Campaign HTML Report">
                <v-icon small>mdi-web</v-icon>
              </v-btn>
              <!-- Manage Permissions Button -->
              <v-btn v-if="buttonShow('settings')" @click="changeSettings(item)" data-toggle="tooltip" data-placement="top" title="Change Settings" aria-label="Change Settings" color="secondary" class="ims-action">
                <i class="fas fa-sliders-h"></i>
              </v-btn>
              <!-- Delete Button -->
              <v-btn
                v-if="buttonShow('delete')"
                data-toggle="tooltip"
                data-placement="top"
                title="Delete Campaign"
                aria-label="Delete Campaign"
                @click="deleteCampaign(item.id)"
                color="error"
                class="ims-action"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
              <!-- Edit Button -->
              <v-btn v-if="buttonShow('edit')" @click="getCampaignDataToEdit(item.id)" color="info" class="ims-action" data-toggle="tooltip" data-placement="top" title="Edit Campaign" aria-label="Edit Campaign">
                <v-icon color="white" small>edit</v-icon>
              </v-btn>
              <!-- View Button -->
              <v-btn v-if="buttonShow('view')" @click="getCampaignDataToView(item.id)" color="info" class="ims-action" data-toggle="tooltip" data-placement="top" title="View Campaign" aria-label="View Campaign">
                <v-icon color="white" small>remove_red_eye</v-icon>
              </v-btn>
              <!-- View Button -->
              <v-btn
                v-if="buttonShow('viewByClient')"
                @click="viewCampaignByClient(item.id)"
                color="info"
                class="ims-action"
                :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
                data-toggle="tooltip"
                data-placement="top"
                title="View Campaign"
                aria-label="View Campaign"
              >
                <v-icon color="white" small >remove_red_eye</v-icon>
              </v-btn>
              <!-- Draft Submit Button -->
              <v-btn
                v-if="buttonShow('draftSubmit')"
                data-toggle="tooltip"
                data-placement="top"
                title="Release to CC"
                @click="approveCampaign(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <!-- Release to Admin -->
              <v-btn
                v-if="buttonShow('releaseToAdmin')"
                :disabled="item.releasedToAdmin"
                data-toggle="tooltip"
                data-placement="top"
                title="Release to Admin"
                @click="releaseToAdmin(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>mdi-send</v-icon>
              </v-btn>
              <!-- Pending Approval "Accept" Button -->
              <v-btn
                v-if="buttonShow('clientApprove')"
                data-toggle="tooltip"
                data-placement="top"
                title="Accept Campaign"
                @click="proceedApproveCampaign(item.id)"
                color="success"
                class="ims-action"
                :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <!-- Activate/Deactivate the campaign after client made payment -->
              <v-btn
                v-if="buttonShow('activate')"
                v-show="item.activated == 0 || item.activated == undefined"
                data-toggle="tooltip"
                data-placement="top"
                title="Release to Client"
                @click="showAMCCInputsDialog(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>work</v-icon>
              </v-btn>
              <!-- Direct release to client -->
              <v-btn
                v-if="buttonShow('directClient') && item.campaignType !== 'Storytell'"
                data-toggle="tooltip"
                data-placement="top"
                title="Direct release to Client"
                @click="directClient(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>work</v-icon>
              </v-btn>
              <v-btn
                v-if="buttonShow('activate')"
                v-show="item.activated == 1"
                data-toggle="tooltip"
                data-placement="top"
                title="Deactivate Campaign"
                @click="activateCampaign(item.id, campaignActivationStatusConfig.DEACTIVATED)"
                color="error"
                class="ims-action"
              >
                <v-icon color="white" small>work_off</v-icon>
              </v-btn>
              <!-- Influencer Pairing "View" Button -->
              <v-btn v-if="buttonShow('viewPairing')" @click="viewInfluencerPairingModal(item)" color="primary" class="ims-action" title="View Pairing Influencers" aria-label="View Pairing Influencers">
                <v-icon color="secondary" small data-toggle="tooltip" data-placement="top" title="View Pairing Influencers"
                  >mdi-account-convert</v-icon
                >
              </v-btn>
              <!-- Influencer Elimination Button by Client -->
              <v-btn
                v-if="buttonShow('eliminating')"
                color="primary"
                class="ims-action"
                :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
                @click="startEliminate(item.id)"
                title="View Pairing Influencers"
                aria-label="View Pairing Influencers"
              >
                <i class="fas fa-users-cog secondary--text" data-toggle="tooltip" data-placement="top" title="View Pairing Influencers"></i>
              </v-btn>
              <!-- Pairing "Start" Button -->
              <v-btn
                v-if="buttonShow('startCampaign')"
                data-toggle="tooltip"
                data-placement="top"
                title="Start Campaign"
                @click="proceedApproveCampaign(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon small>done</v-icon>
              </v-btn>
              <!-- Ongoing "Close" Button -->
              <v-btn
                v-if="buttonShow('reviewCampaign')"
                data-toggle="tooltip"
                data-placement="top"
                title="Push to Review"
                @click="pushReviewCampaign(item.id)"
                color="primary"
                class="ims-action"
              >
                <v-icon color="secondary" small>mdi-progress-upload</v-icon>
              </v-btn>
              <!-- Ongoing "Close" Button -->
              <v-btn
                v-if="buttonShow('closeCampaign')"
                data-toggle="tooltip"
                data-placement="top"
                title="Close Campaign"
                @click="proceedApproveCampaign(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>power_settings_new</v-icon>
              </v-btn>
              <!-- View Brand Fact Sheet "Accept" Button -->
              <v-btn
                v-if="buttonShowBrandSheet(item)"
                data-toggle="tooltip"
                data-placement="top"
                title="View Brand Fact Sheet"
                @click="openBrandSheetModalDialog(item)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>mdi-file-document</v-icon>
              </v-btn>
              <!-- Pairing Brief "Edit" Button -->
              <v-btn
                v-if="buttonShow('pairingBrief')"
                data-toggle="modal"
                :data-target="editPairingBriefModalIdDisplay"
                @click="getCampaignDataToEdit(item.id)"
                color="info"
                class="ims-action"
                title="Edit Pairing Brief"
                aria-label="Edit Pairing Brief"
              >
                <v-icon data-toggle="tooltip" data-placement="top" title="Edit Pairing Brief" color="white" small>rate_review</v-icon>
              </v-btn>
              <!-- Pairing Brief "View" Button -->
              <v-btn
                v-if="buttonShow('pairingBrief')"
                data-toggle="modal"
                :data-target="viewPairingBriefModalIdDisplay"
                @click="getCampaignDataToView(item.id)"
                color="info"
                class="ims-action"
                title="View Pairing Brief"
                aria-label="View Pairing Brief"
              >
                <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="View Pairing Brief">pageview</v-icon>
              </v-btn>
              <!-- Pairing Brief "Accept" Button -->
              <v-btn
                v-if="buttonShow('pairingBrief')"
                data-toggle="tooltip"
                data-placement="top"
                title="Accept Pairing Brief"
                @click="proceedApproveCampaign(item.id)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <!-- Influencer Pairing "Accept" Button -->
              <v-btn
                v-if="buttonShow('influencerAccept') && buttonShowPairing(item.pairingStatus)"
                data-toggle="tooltip"
                data-placement="top"
                title="Accept Pairing Influencer"
                @click="acceptInvite(item.pairingID)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <!-- Influencer Pairing "Reject" Button -->
              <v-btn
                v-if="buttonShow('influencerAccept') && buttonShowPairing(item.pairingStatus)"
                data-toggle="tooltip"
                data-placement="top"
                title="Reject Pairing Influencer"
                @click="rejectInvite(item.pairingID)"
                color="error"
                class="ims-action"
              >
                <v-icon color="white" small>done</v-icon>
              </v-btn>
              <!-- Post "view" Button -->
              <!-- <v-btn
                v-if="buttonShow('viewPost') && !buttonShowPairing(item.pairingStatus)"
                data-toggle="modal"
                :data-target="viewPostModalIdDisplay"
                @click="getPostDataToView(item)"
                color="success"
                class="ims-action"
              >
                <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="View Posts">library_books</v-icon>
              </v-btn> -->
              <!-- View influencer list -->
              <v-btn
                v-if="buttonShow('viewInfluencers') && !buttonShowPairing(item.pairingStatus)"
                @click="getPairedInfluencers(item)"
                color="success"
                class="ims-action"
                data-toggle="tooltip" data-placement="top" title="View Influencers"
              >
                <v-icon color="white" small >people</v-icon>
                <v-badge color="error" :content="getSubmittedCount(item)" v-if="payoutSubmittedPairings.length > 0 && getSubmittedCount(item) > 0"></v-badge>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- CreateCampaign modal -->
    <create-campaign-modal v-model="createModalDialog" :value="createModalDialog" @createCampaign="createCampaign" />

    <!-- EditCampaign modal -->
    <edit-campaign-modal v-model="editModalDialog" :value="editModalDialog" :campaignId="editCampaignId" @editCampaign="editCampaign" />

    <!-- ViewCampaign modal -->
    <view-campaign-modal v-model="viewModalDialog" :value="viewModalDialog" :campaignData="viewCampaignData" />

    <!-- EditPairingBrief modal -->
    <edit-pairing-brief-modal :modalId="editPairingBriefModalId" :campaignId="editCampaignId" @editCampaign="editCampaign" />

    <!-- ViewPairingBrief modal -->
    <view-pairing-brief-modal :modalId="viewPairingBriefModalId" :campaignData="viewCampaignData" />

    <!-- ViewPairing modal -->
    <view-pairing-modal v-model="viewPairingModalDialog"
    :value="viewPairingModalDialog"
    :campaignData="viewPairingCampaignData"
    :client="campaignClient"
    :unlockCogs="isUnlockCogs"
    @setUnlockCogs="setUnlockCogs" />

    <!-- Influencer Elimination by Client -->
    <influencer-elimination v-model="eliminationDialog" :campaingData="campaingDataForElimination" />

    <!-- ViewPost modal -->
    <view-post-modal :modalId="viewPostModalId" :campaignData="viewPostCampaignData" />
    <!-- Cilent View Influencer Dialog -->
    <v-dialog v-model="viewInfluencerDialog" max-width="1250">
      <v-card>
        <v-card-title>
          <span class="headline">Paired influencers for campaign</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Contents</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.min_content }} to {{ campaignCOEB.max_content }}</p>
                    <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.totalPercentage}} %</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Outreach</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.outreach | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.outreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.outreachPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Engagement</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.engagement | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.engagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.engagementPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3" v-if="isNotClientRole">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Budget</v-card-title>
            <v-card-subtitle>
              <p class="pa-0 ma-0 custom-font">Target : {{ budget | currency }}</p>
              <p class="pa-0 ma-0 custom-font">COGS: {{measurement.budget | currency}}</p>
              <p class="pa-0 ma-0 custom-font">Approved COGS: {{measurement.invitedBudget | currency}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited COGS: {{measurement.notInvitedBudget | currency}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Percentage: {{measurement.cogsPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
          </v-row>
        </v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Handle</th>
                <th class="text-left">Followers</th>
                <th class="text-left">Eng. Rate</th>
                <th class="text-left">Aud. Cred</th>
                <th class="text-left" v-if="isNotClientRole">Status</th>
                <th class="text-left">Elimination Status</th>
                <th class="text-right" v-if="isNotClientRole">Payout Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pairedInfluencers" :key="item.instagramHandle">
                <td>
                  <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                  <a :href="'https://youtube.com/' + item.instagramHandle" target="_blank" v-else-if="item.influencer_details.platform === 'youtube'"><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>
                  <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>

                </td>
                <td>{{ item.followers }}</td>
                <td>{{ item.engagement_rate }}%</td>
                <td>
                  <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                  {{ item.audience_credibility }}
                </td>
                <td v-if="isNotClientRole">
                  <v-chip class="ma-2" outlined x-small>
                    {{pairingStatusDisplay[item.pairingStatus]}}
                    <v-icon right x-small>mdi-circle-edit-outline</v-icon>
                  </v-chip>
                </td>
                <td>
                  <v-chip
                    class="ma-2"
                    :color="eliminatinStatusColor(item.eliminationStatus)"
                    v-on="on"
                    x-small
                    text-color="white"
                  >
                    {{ eliminationStatusDisplay(item.eliminationStatus) }}
                    <v-icon right x-small>mdi-check</v-icon>
                  </v-chip>
                </td>
                <td class="text-right" v-if="isNotClientRole">$ {{ item.payoutAmount }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="viewInfluencerDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End of Client View Influencer Dialog -->

    <!-- Admin View Influencer Dialog -->
    <v-dialog v-model="viewInfluencerAdminDialog" max-width="1250" content-class="ims-standard-dialog">
      <v-card class="ims-modal-card">
        <v-card-title class="title ims-modal-header">
          <span class="headline">
            Paired influencers for campaign:
            <strong>{{ campaignCOEB.campaignName }}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="secondary" aria-label="Close" title="Close" @click="viewInfluencerAdminDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="ims-modal-body">
          <v-row>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Contents</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.min_content }} to {{ campaignCOEB.max_content }}</p>
                    <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.totalPercentage}} %</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Outreach</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.outreach | thousandSeprator}}</p>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Current Total: {{measurement.outreach | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedOutreach | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedOutreach | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.outreachPercentage}}%</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Engagement</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.engagement | thousandSeprator}}</p>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Current Total: {{measurement.engagement | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedEngagement | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedEngagement | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.engagementPercentage}}%</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3" v-if="isNotClientRole">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Budget</v-card-title>
                  <v-card-subtitle>
                    <p class="pa-0 ma-0 custom-font">Target : {{ budget | currency }}</p>
                    <p class="pa-0 ma-0 custom-font">COGS: {{measurement.budget | currency}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved COGS: {{measurement.invitedBudget | currency}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited COGS: {{measurement.notInvitedBudget | currency}}</p>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Percentage: {{measurement.cogsPercentage}}%</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <v-row class="mt-0" style="justify-content:right;">
            <v-col cols="12" sm="3" md="3" lg="3">
              <v-select
                class="input-field pt-3"
                v-model="pairedFilter.payoutStatus"
                :items="payoutStatusOptions"
                item-value="status"
                item-text="display"
                label="Payout Status"
                dense
                outlined
                @change="pairingSearchFilter"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="5" md="5" lg="5">
              <v-text-field
                v-model="pairedFilter.search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="pairedHeaders"
                :items="pairedFilterItems"
                :items-per-page="10"
                :search="pairedFilter.search"
                :no-data-text="'Empty list'"
                class="elevation-1 page__table"
                :key="dataTableKey"
              >
                <template v-slot:body="props">
                  <tbody>
                    <tr
                    v-for="item in props.items"
                    :key="item.instagramHandle"
                    v-bind:class="{'yellow lighten-4': item.payoutSubmitted}">
                      <td>
                        <social-handle
                          divClassName="d-inline"
                          :isTikTok="item.influencer_details.platform === 'tiktok'"
                          :isInstagram="!item.influencer_details.platform || item.influencer_details.platform === 'instagram'"
                          :isYoutube="item.influencer_details.platform === 'youtube'"
                          :isFacebook="item.influencer_details.platform === 'facebook'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                        />
                        <!-- <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                        <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a> -->
                      </td>
                      <td class="text-center">
                        <span v-if="item.influencer_details.platform === 'facebook'">-</span>
                        <span v-else>{{ item.followers }}</span>
                      </td>
                      <td>
                        <span v-if="item.influencer_details.platform === 'facebook'">-</span>
                        <span v-else>{{ item.engagement_rate }}%</span>
                      </td>
                      <td>
                        <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                        {{ item.audience_credibility }}
                      </td>
                      <td>{{ item.deliverables }}</td>
                      <td v-if="isNotClientRole">
                        <v-chip class="ma-2" :color="payoutStatusColor(item.payoutStatus)" outlined small>
                          {{ payoutStatusDisplay[item.payoutStatus || 0] }}
                          <v-icon right x-small>mdi-circle-edit-outline</v-icon>
                        </v-chip>
                      </td>
                      <!-- <td>
                        <v-chip
                          class="ma-2"
                          :color="eliminatinStatusColor(item.eliminationStatus)"
                          v-on="on"
                          x-small
                          text-color="white"
                        >
                          {{ eliminationStatusDisplay(item.eliminationStatus) }}
                          <v-icon right x-small>mdi-check</v-icon>
                        </v-chip>
                      </td> -->
                      <td class="text-right" v-if="isNotClientRole">$ {{ item.payoutAmount }}</td>
                      <td class="text-center paired-actions-cell">
                        <div class="paired-actions">
                          <v-tooltip top v-if="buttonShow('editPayout')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="secondary"
                                class="paired-action-btn"
                                aria-label="Edit payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="openConfirmPayoutDialog(item)"
                              >
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit payout</span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus !== payoutStatus.CONFIRMED"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="primary"
                                class="paired-action-btn"
                                aria-label="Confirm payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="updateSend(item)"
                              >
                                <v-icon small color="secondary">mdi-check</v-icon>
                              </v-btn>
                            </template>
                            <span>Confirm payout</span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus === payoutStatus.CONFIRMED"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="error"
                                class="paired-action-btn"
                                aria-label="Cancel payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="cancelPayout(item)"
                              >
                                <v-icon small>mdi-cancel</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancel payout</span>
                          </v-tooltip>
                          <v-tooltip top v-if="buttonPayoutViewShow(item)">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                class="paired-action-btn ims-btn-third"
                                aria-label="View payouts"
                                v-bind="attrs"
                                v-on="on"
                                @click="linkPayoutInternal(item)"
                              >
                                <v-icon small>mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View payouts</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Handle</th>
                <th class="text-left">Followers</th>
                <th class="text-left">Eng. Rate</th>
                <th class="text-left">Aud. Cred</th>
                <th class="text-left">Deliverable Details</th>
                <th class="text-left" v-if="isNotClientRole">Status</th>
                <th class="text-right" v-if="isNotClientRole">Payout Amount</th>
                <th class="text-right" v-if="isNotClientRole">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
              v-for="item in pairedInfluencers"
              :key="item.instagramHandle"
              v-bind:class="{'yellow lighten-4': item.payoutSubmitted}">
                <td>
                  <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                  <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>
                </td>
                <td>{{ item.followers }}</td>
                <td>{{ item.engagement_rate }}%</td>
                <td>
                  <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                  {{ item.audience_credibility }}
                </td>
                <td>{{ item.deliverables }}</td>
                <td v-if="isNotClientRole">
                  <v-chip class="ma-2" :color="payoutStatusColor(item.payoutStatus)" outlined small>
                    {{ payoutStatusDisplay[item.payoutStatus || 0] }}
                    <v-icon right x-small>mdi-circle-edit-outline</v-icon>
                  </v-chip>
                </td>
                <td class="text-right" v-if="isNotClientRole">$ {{ item.payoutAmount }}</td>
                <td class="text-center">
                  <v-btn
                    class="ma-1"
                    @click="openConfirmPayoutDialog(item)"
                    color="warning"
                    small
                    v-if="buttonShow('editPayout')"
                  >
                    <v-icon small>edit</v-icon> Edit Payout
                  </v-btn>
                  <v-btn
                  class="ma-1"
                  v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus !== payoutStatus.CONFIRMED"
                  color="success"
                  small
                  @click="updateSend(item)">
                    <v-icon left>mdi-check</v-icon> Confirm Payout
                  </v-btn>
                  <v-btn
                  class="mb-1"
                  color="error"
                  small
                  @click="cancelPayout(item)"
                  v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus === payoutStatus.CONFIRMED">
                    <v-icon left>mdi-cancel</v-icon> Cancel Payout
                  </v-btn>
                  <v-btn
                  class="ma-1"
                  v-if="buttonPayoutViewShow(item)"
                  @click="linkPayoutInternal(item)"
                  color="warning"
                  dense
                  small>
                    <v-icon left>remove_red_eye</v-icon> View Payouts
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
        <v-card-actions class="ims-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="viewInfluencerAdminDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End of Admin View Influencer Dialog -->

    <!-- Campaign Payout Dialog -->
    <payout-confirm-modal  v-model="payoutConfirmDialog" :value="payoutConfirmDialog" :data="payoutConfirmData"
      :influencer="influencer" @confirmedPayout="setConfirmedPayout"/>

    <!-- Campaign Settings Dialog -->
    <campaign-settings :campaign="viewCampaignData" @saved="reload" v-model="campaignSettingsDialog" />

    <!-- view campaign status modal -->
    <view-client-modal :clientData="viewClientData" v-model="viewClientDialog"/>

    <!-- view brand sheet fact modal -->
    <view-brand-sheet-modal v-model="viewBrandSheetModalDialog" :value="viewBrandSheetModalDialog" :brandSheetData="viewbrandSheetData" />

    <!-- Influencer Detail Modal -->
    <influencer-detail-modal
      :dialog="invoiceDialog"
      :influencer="influencer"
      :influencerProfile="influencerProfile"
      :selectedTab="selectedTab"
      :briefDetailContent="briefDetailsHTML"
      :close="closeModal"
      @loadInfluencer="loadInfluencerData"
      @reRenderDatTable="loadInfluencerData"
      @loadingDialogOpen="loadingDialogOpen"
      @loadingDialogClose="loadingDialogClose"
      :newPairingFlow="true"
      :isDownload="invoiceDownload" />
    <!-- End of Influencer Detail Modal -->

    <!-- Change Status Modal -->
    <change-status-modal
      :campaign="campaignDataForStatusChange"
      :campaignIds="selectedCampaignIds"
      @updated="reload"
      v-model="changeStatusDialog"
    />
    <!-- End of Change Status Modal -->

    <!-- All Campaign Reports Passcode Modal -->
    <all-reports-passcode-modal
      :value="allReportsPasscodeDialog"
      v-model="allReportsPasscodeDialog"
      :reportType="downloadReportType"
      @success="reportPasscodeSuccess"
    />
    
    <!-- Release to CC Modal -->
    <release-to-cc-modal
      :campaign="campaignDataForSubmitDraft"
      @saved="proceedApproveCampaign"
      v-model="releaseToCCDialog"
    />
    <!-- End of Release to CC Modal -->

    <!-- Release to Admin Modal -->
    <release-to-admin-modal
      :campaign="campaignDataForAccept"
      @saved="proceedReleaseToAdmin"
      v-model="releaseToAdminDialog"
    />
    <!-- End of Release to CC Modal -->

    <!-- am, cc inputs modal -->
    <am-cc-inputs-modal
      :campaign="campaignDataForRelease"
      source="release"
      v-model="amCCInputsDialog"
      @proceedBrief="showCheckListDialog"
    />
    <!-- end of am, cc inputs modal -->

    <!-- brief release checklist modal -->
    <brief-release-checklist-modal
      :campaign="campaignDataForRelease"
      v-model="briefReleaseChecklistDialog"
      @confirmActivate="proceedActivateCampaign"
    />
    <!-- end of brief release checklist modal -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Masterlist"
      :items="tableColsItems"
      @updated="updateTableCols"
    />

    <!-- invoices & brief confirmation dialog -->
    <invoices-brief-view-modal
      :campaignID="viewCampaignId"
      :value="invoicesBriefViewDialog"
      v-model="invoicesBriefViewDialog"
      @reload="reload"
    />

    <!-- End of All Campaign Reports Passcode Modal -->
    <v-dialog
      v-model="loadingDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import config from '@/config';
import campaignConfig from './config';
import campaignHelper from './campaignHelper';
import store from '@/store';
import campaignAPIs from './campaignAPIs';
import clientAPIs from '../Client/clientAPIs';
import CreateCampaignModal from './CreateCampaignModal';
import EditCampaignModal from './EditCampaignModal';
import ViewCampaignModal from './ViewCampaignModal';
import ReleaseToCcModal from './ReleaseToCcModal';
import ReleaseToAdminModal from './ReleaseToAdminModal';
import BriefReleaseChecklistModal from './BriefReleaseChecklistModal';
import ViewPairingModal from './PairingInfluencer/ViewPairingModal';
import ViewBrandSheetModal from './ViewBrandSheetModal';
import PayoutConfirmModal from './PairingInfluencer/PayoutConfirmModal';
import InvoicesBriefViewModal from './PairingInfluencer/InvoicesBriefViewModal';
import InfluencerElimination from './ViewPairingInfluencerElimination';
import ViewPostModal from './ViewPostModal';
import ViewPairingBriefModal from './ViewPairingBriefModal';
import EditPairingBriefModal from './EditPairingBriefModal';
import influencerDetailModal from './PairingInfluencer/InfluencerDetailViewModal'
import AllReportsPasscodeModal from './AllCampaignsReport/AllReportsPasscodeModal';
import SocialHandle from '../../scoped/custom/SocialHandle'
import ChangeStatusModal from './ChangeCampaignStatusModal';
import AmCcInputsModal from './AmCcInputsModal';
import BlocksToHtml from '../../editor/generator/blocksToHtml'
import CampaignSettings from './CampaignSettingsModal';
import pairingAPIs from '../Pairing/pairingAPIs';
import userAPIs from '../User/userAPIs';
import campaignPDF from './campaignPDF'
import utils from '../../../utils';
import reverse from 'lodash/reverse';
// import orderBy from 'lodash/orderBy';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import countries from '../../../../static/sources/countries';

export default {
  name: 'Campaign',
  components: {
    CreateCampaignModal,
    EditCampaignModal,
    ViewCampaignModal,
    ViewPairingBriefModal,
    EditPairingBriefModal,
    ViewPairingModal,
    ViewBrandSheetModal,
    PayoutConfirmModal,
    influencerDetailModal,
    ChangeStatusModal,
    InfluencerElimination,
    ViewPostModal,
    CampaignSettings,
    SocialHandle,
    AllReportsPasscodeModal,
    ReleaseToCcModal,
    ReleaseToAdminModal,
    AmCcInputsModal,
    BriefReleaseChecklistModal,
    TableColsShowHideModal,
    InvoicesBriefViewModal
  },
  data() {
    return {
      createModalDialog: false,
      editModalDialog: false,
      viewInfluencerDialog: false,
      viewInfluencerAdminDialog: false,
      payoutConfirmDialog: false,
      invoiceUploadDialog: false,
      pairedInfluencers: [],
      viewModalDialog: false,
      viewPairingModalDialog: false,
      viewBrandSheetModalDialog: false,
      allReportsPasscodeDialog: false,
      payoutConfirmData: {},
      eliminationDialog: false,
      viewPairingModalId: 'view_pairing_modal',
      editPairingBriefModalId: 'edit_pairing_brief_modal',
      viewPairingBriefModalId: 'view_pairing_brief_modal',
      viewPostModalId: 'view_post_modal',
      viewCampaignId: null,
      editCampaignId: null,
      viewCampaignData: null,
      campaingDataForElimination: null,
      viewPairingCampaignData: null,
      viewPostCampaignData: null,
      campaignSettingsDialog: false,
      colSettingsDialog: false,
      invoicesBriefViewDialog: false,
      colStatuses: {},
      tableColsItems: [],
      userProfile: {},
      sortBy: 'name',
      sortDesc: false,
      allClients: [],
      loading: false,
      headers: [
        {
          text: 'Billing Name as per Xero',
          value: 'clientName'
        },
        {
          text: 'Campaign Name',
          value: 'name'
        },
        {
          text: 'Campaign Type',
          value: 'campaignType'
        },
        // {
        //   text: 'Unique Code',
        //   value: 'campaignCode'
        // },
        {
          text: 'IO Number',
          value: 'ioNumbers'
        },
        {
          text: 'Budget',
          value: 'budget'
        },
        {
          text: 'COGS Capped',
          value: 'target'
        },
        {
          text: 'COGS Current',
          value: 'cogs'
        },
        {
          text: 'COGS %',
          value: 'cogsPercentage'
        },
        {
          text: 'AM',
          value: 'AM'
        },
        {
          text: 'CC',
          value: 'CO'
        },
        // {
        //   text: 'Payout Status',
        //   value: 'payoutStatus'
        // },
        {
          text: 'Updated On',
          value: 'updatedAtDisplay'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      clientHeaders: [
        {
          text: 'Campaign Name',
          value: 'name'
        },
        // {
        //   text: 'Unique Code',
        //   value: 'campaignCode'
        // },
        {
          text: 'Updated On',
          value: 'updatedAtDisplay'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      allCampaignHeaders: [
        {
          text: 'IO Number',
          value: 'ioNumbers'
        },
        // {
        //   text: 'Campaign Code',
        //   value: 'campaignCode'
        // },
        {
          text: 'Billing Name as per Xero',
          value: 'clientName'
        },
        {
          text: 'Campaign Name',
          value: 'name'
        },
        {
          text: 'Campaign Type',
          value: 'campaignType'
        },
        {
          text: 'Country (Location)',
          value: 'countryDisplay'
        },
        {
          text: 'Vertical',
          value: 'vertical'
        },
        {
          text: 'Budget',
          value: 'budget'
        },
        // {
        //   text: 'Revenue Recognized',
        //   value: 'revenueRecognized'
        // },
        // {
        //   text: 'Unrecognized Revenue',
        //   value: 'unrecognizedRevenue'
        // },
        {
          text: 'COGS Capped',
          value: 'target'
        },
        {
          text: 'COGS Current',
          value: 'cogs'
        },
        {
          text: 'COGS %',
          value: 'cogsPercentage'
        },
        {
          text: 'Stage',
          value: 'campaignStatusDisplay'
        },
        {
          text: 'AM',
          value: 'AM'
        },
        {
          text: 'CC',
          value: 'CO'
        },
        {
          text: 'Campaign Period',
          value: 'campaignPeriod'
        },
        {
          text: 'Start Month',
          value: 'startMonth'
        },
        {
          text: 'End Month',
          value: 'endMonth'
        },
        {
          text: 'First Post Date',
          value: 'firstPostDate'
        },
        {
          text: 'Last Post Date',
          value: 'lastPostDate'
        },
        // {
        //   text: 'Payout Status',
        //   value: 'payoutStatus'
        // },
        {
          text: 'Updated On',
          value: 'updatedAtDisplay'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      AM: [],
      CO: [],
      campaignVerticals: [],
      verifiedFilters: ['All', 'Verified Payouts'],
      selectedFilter: {
        campaignType: '',
        vertical: '',
        targetLocation: '',
        AM: '',
        CO: '',
        client: '',
        stage: 'All',
        verified: 'All',
        searchStartMonth: '',
        searchLastMonth: '',
        htmlReport: false,
        archive: true
      },
      items: [],
      filteredItems: [],
      pagination: {
        rowsPerPage: 15
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      filter: '',
      campaignStatuses: config.campaignStatus,
      pairingStatusDisplay: campaignConfig.pairingStatusDisplay,
      payoutStatusDisplay: campaignConfig.payoutStatusDisplay,
      payoutStatus: campaignConfig.payoutStatus,
      campaignModelSections: campaignConfig.campaignModelSections,
      campaignModelSectionType: campaignConfig.campaignModelSectionType,
      campaignStageDisplay: campaignConfig.campaignStageDisplay,
      campaignStage: campaignConfig.campaignStage,
      campaignTypeDisplayFilter: campaignConfig.campaignTypeDisplay,
      targetLocationDisplayFilter: campaignConfig.targetAudienceDisplay.LOCATION,
      tableActions: campaignConfig.tableActions,
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      copyrightText: 'All Rights Reserved. © Kobe Global Technologies Pte Ltd',
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      brandSheets: [],
      invoiceDownload: false,
      invoiceDialog: false,
      influencer: '', // for Influencer Detail Modal
      influencerProfile: '', // for Influencer Detail Modal
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      selectedTab: '',
      loadingDialog: false,
      payoutSubmittedPairings: [],
      pairedHeaders: [
        {
          text: 'Handle',
          value: 'instagramHandle'
        },
        {
          text: 'Followers',
          value: 'followers'
        },
        {
          text: 'Eng. Rate',
          value: 'engagement_rate'
        },
        {
          text: 'Aud. Cred',
          value: 'audience_credibility'
        },
        {
          text: 'Deliverable Details',
          value: 'deliverables'
        },
        {
          text: 'Status',
          value: 'payoutStatus'
        },
        {
          text: 'Payout Amount',
          value: 'payoutAmount'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      pairedFilter: {
        payoutStatus: '',
        search: ''
      },
      pairedFilterItems: [],
      campaignDataForStatusChange: null,
      campaignDataForSubmitDraft: null,
      campaignDataForAccept: null,
      campaignDataForRelease: null,
      selectedCampaigns: [],
      selectedCampaignIds: [],
      campaignClient: {},
      releaseToCCDialog: false,
      releaseToAdminDialog: false,
      changeStatusDialog: false,
      amCCInputsDialog: false,
      briefReleaseChecklistDialog: false,
      countries: [], // For filter influencer
      startMonthPicker: false,
      selectedStartMonth: '',
      endMonthPicker: false,
      selectedEndMonth: '',
      downloadReportType: '',
      exportType: '',
      isUnlockCogs: false,
      showActionsColumn: true
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      campaignUpdated: state => state.campaign.campaignUpdated,
      // countries: state => state.campaign.countries,
      reports: state => state.campaign.reports,
      influencers: state => state.influencer.influencers
    }),
    computedAllCampaignHeaders() {
      let allCampaignCols = null
      let headers = Object.assign([], this.allCampaignHeaders)
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.allCampaignCols) {
          allCampaignCols = Object.assign({}, this.userProfile.tableSettings.allCampaignCols)
        }
      }
      if (allCampaignCols) {
        this.colStatuses = Object.assign({}, allCampaignCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return headers.filter(h => {
        if (h.value === 'action') {
          return this.showActionsColumn
        }
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedCampaignHeaders() {
      const headers = this.isNotClientRole ? this.headers : this.clientHeaders;
      return this.showActionsColumn ? headers : headers.filter(header => header.value !== 'action');
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    updatedOn: function () {
      return moment(this.lastUpdate).fromNow();
    },
    editPairingBriefModalIdDisplay: function () {
      return '#' + this.editPairingBriefModalId;
    },
    viewPairingBriefModalIdDisplay: function () {
      return '#' + this.viewPairingBriefModalId;
    },
    viewPostModalIdDisplay: function () {
      return '#' + this.viewPostModalId;
    },
    campaignStatus: function () {
      return this.$route.meta.campaignStatus;
    },
    isArchive: function () {
      return this.$route.meta.archive || false;
    },
    campaignActivationStatusConfig: function () {
      return campaignConfig.campaignActivationStatus;
    },
    isNotClientRole: function () {
      // show paired amount except for client side
      return Number(this.$store.state.user.role) !== config.userRoles.CLIENT;
    },
    budget: function() {
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaignCOEB.budget * 0.3)
    },
    markupCOGSAmount: function() {
      let campaignClient = this.allClients.find(client => client.id === this.campaignCOEB.clientID)
      return campaignHelper.getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient)
    },
    showConfirmPayout: function() {
      return campaignHelper.isAOKCampaign(this.campaignCOEB.campaignType)
    },
    payoutStatusOptions: function() {
      let data = [];
      Object.entries(this.payoutStatusDisplay).forEach(item => {
        data.push({
          status: item[0],
          display: item[1]
        });
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    }
  },
  watch: {
    campaignStatus: function (newCampaignStatus) {
      // Get the corresponding campaign list whenever campaign status reacts
      this.paginate(1);
    },
    isArchive: function (newValue) {
      this.paginate(1);
    },
    currentPage() {
      this.paginate(this.currentPage);
    },
    pagination: {
      handler() {
        this.currentPage = this.pagination.page
      },
      deep: true
    }
    // filter: function() {
    //   this.paginate(this.currentPage)
    // }
  },
  methods: {
    constructImageURL: function(imageName) {
      return utils.func.constructImageURL(imageName);
    },
    getDisplayValueFromSelect: function(selectList, value) {
      var selectedOption = selectList.find(option => {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    },
    // convert to base64 dataURL
    toDataURL: url =>
      fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        ),
    checkForVendorFormComplete() {
      clientAPIs
        .getClient(this.user.clientID)
        .then(response => {
          let client = response;
          if (!client.acceptTerms) {
            this.$swal({
              title: 'Complete the Vendor Creation Form',
              type: 'info',
              text: 'You need to complete the vendor creation form and accept the terms to continue.'
            }).then(() => this.$router.push({ path: '/client/vendor-creation-form' }));
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    startEliminate(campaignID) {
      this.$swal({
        title: campaignConfig.campaignConfirmation.pairingTermsAndCondition.title,
        html: campaignConfig.campaignConfirmation.pairingTermsAndCondition.html,
        type: 'info',
        width: 500,
        backdrop: `rgba(0,0,1, 0.9)`,
        showCancelButton: true,
        confirmButtonText: campaignConfig.campaignConfirmation.pairingTermsAndCondition.confirmButtonText,
        cancelButtonText: campaignConfig.campaignConfirmation.pairingTermsAndCondition.cancelButtonText,
        allowOutsideClick: false
      }).then(result => {
        if (!result.value) {
          this.eliminationDialog = false;
        } else {
          campaignAPIs
            .getCampaign(campaignID)
            .then(response => {
              this.campaingDataForElimination = Object.assign({}, response);
              this.eliminationDialog = true;
            })
            .catch(error => {
              this.eliminationDialog = false;
              console.log('error', error);
            });
        }
      });
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }
      return false;
    },
    buttonShowPairing(pairingStatus) {
      if (pairingStatus === campaignConfig.pairingStatus.INVITED) {
        return true;
      }
      return false;
    },
    buttonShowBrandSheet(item) {
      const buttonPermission = config['userPermissions']['campaign']['viewBrandFactSheet'];
      let hasBrandSheet = this.brandSheets.some(b => b.campaignID === item.id)
      if (buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(item.status) && hasBrandSheet) {
        return true
      }
      return false
    },
    buttonPayoutViewShow(item) {
      const buttonPermission = config['userPermissions']['campaign']['viewPayout']
      if (buttonPermission.userRoles.includes(this.currentUserRole) && item.payoutVerified !== undefined) {
        return true
      }
      return false
    },
    reload() {
      this.paginate(1);
    },
    updateItems(response) {
      let campaigns = response.campaigns;
      campaigns = campaigns.map(item => {
        item.campaignType = this.getProductName(item.campaignType)
        item.vertical = this.formatCampaignVerticals(item)
        item.verticalDisplay = item.vertical.map(v => v.name || '').join(', ')
        item.countryDisplay = this.getCountryDisplayValueFromSelect(item.targetLocation || [])
        item.campaignStatusDisplay = this.getStageName(item.status);
        item.updatedAtDisplay = this.formatTime(item.updatedAt);
        item.clientName = this.getClientName(item.clientID);
        item.AM = this.AM.filter(am => item.assignedTo && item.assignedTo.includes(am.id)).map(am => am.name).join(', ')
        item.CO = this.CO.filter(co => item.assignedTo && item.assignedTo.includes(co.id)).map(co => co.name).join(', ')
        // let campaignClient = this.allClients.find(client => client.id === item.clientID)
        // item.markupCOGS = campaignHelper.getMarkupCOGS(item.ioNumbers, campaignClient)
        // item.target = item.markupCOGS || Math.floor(item.budget * 0.3)
        item.payoutStatus = item.payoutStatus || ''
        if (item.payoutStatus && item.payoutStatus === this.payoutStatus.CONFIRMED) {
          item.payoutStatusDisplay = this.payoutStatusDisplay[item.payoutStatus]
        } else {
          item.payoutStatusDisplay = 'Pending Payout'
        }
        // item.AM = item.AM.map(am => am.name).join(', ')
        // item.CO = item.CO.map(co => co.name).join(', ')
        return item;
      });

      this.items = campaigns;
      this.searchFilter()
      this.totalRows = this.filteredItems.length;
      this.getReportsByCampaignIDs(campaigns)
    },
    paginate(page = 1) {
      this.clearSelectedCampaigns()
      this.currentPage = page;
      this.loading = true;
      if (this.isArchive) this.selectedFilter.archive = false // force archive only if archived campaign view
      campaignAPIs
        .paginate({
          page: page,
          status: this.campaignStatus,
          archive: this.isArchive,
          includeArchive: this.selectedFilter.archive,
          // keyword: this.filter,
          sort: 'updatedAt DESC'
        })
        .then(response => {
          this.loading = false;
          this.updateItems(response);
          this.checkShowURLParam()
        })
        .catch(error => {
          this.loading = false;
          console.log('error', error);
        });
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.assignedTo && item.assignedTo.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CO) {
        this.filteredItems = this.filteredItems.filter(item => (item.assignedTo && item.assignedTo.includes(this.selectedFilter.CO)))
      }
      if (this.selectedFilter.client) {
        this.filteredItems = this.filteredItems.filter(item => (item.clientID && item.clientID === this.selectedFilter.client))
      }
      if (this.selectedFilter.campaignType) {
        if (this.selectedFilter.campaignType === -1) {
          this.filteredItems = this.filteredItems.filter(item => {
            if (item.campaignType) {
              return !this.campaignTypeDisplayFilter.some(v => item.campaignType.includes(v.value))
            } else return true
          })
          this.filteredItems = this.filteredItems.filter(item => !item.campaignType)
        } else {
          this.filteredItems = this.filteredItems.filter(item => (item.campaignType && item.campaignType === this.selectedFilter.campaignType))
        }
      }
      if (this.selectedFilter.vertical) {
        if (this.selectedFilter.vertical === -1) {
          this.filteredItems = this.filteredItems.filter(item => {
            let filterVerticals = []
            if (Array.isArray(item.vertical)) {
              filterVerticals = item.vertical.map(v => v.id)
            }
            if (filterVerticals) {
              return !this.campaignVerticals.some(v => filterVerticals.includes(v.id))
            } else return true
          })
        } else {
          this.filteredItems = this.filteredItems.filter(item => {
            let filterVerticals = []
            if (Array.isArray(item.vertical)) {
              filterVerticals = item.vertical.map(v => v.id)
            }
            return (filterVerticals && filterVerticals.includes(this.selectedFilter.vertical))
          })
        }
      }
      if (this.selectedFilter.targetLocation) {
        this.filteredItems = this.filteredItems.filter(item => (item.targetLocation && item.targetLocation.includes(this.selectedFilter.targetLocation)))
      }

      if (this.selectedFilter.stage) {
        const stage = this.selectedFilter.stage
        this.filteredItems = this.filteredItems.filter(item => {
          // All Campaign, no need checking
          if (stage === this.campaignStage.ALL) {
            return true
          }
          // Activating Stage
          if (stage === this.campaignStage.ACTIVATING) {
            if (item.status === this.campaignStatuses.DRAFT || item.status === this.campaignStatuses.PENDING_CLIENT_APPROVAL) {
              return true
            }
          }
          // Pairing Stage
          if (stage === this.campaignStage.PAIRING) {
            if (item.status === this.campaignStatuses.PAIRING_BRIEF || item.status === this.campaignStatuses.PAIRING_INFLUENCER || item.status === this.campaignStatuses.RATE_CARD) {
              return true
            }
          }
          // Co-creating Stage
          if (stage === this.campaignStage.COCREATING && item.status === this.campaignStatuses.ONGOING) {
            return true
          }
          // Review Stage
          if (stage === this.campaignStage.REVIEW && item.status === this.campaignStatuses.REVIEW) {
            return true
          }
          // Complete Stage
          if (stage === this.campaignStage.COMPLETE && item.status === this.campaignStatuses.COMPLETE) {
            return true
          }
          return false
        })
      }
      // verified filter
      if (this.selectedFilter.verified === 'Verified Payouts') {
        let campaignIDs = this.payoutSubmittedPairings.map(p => p.campaignID)
        this.filteredItems = this.filteredItems.filter(item => campaignIDs.includes(item.id))
      }
      // start month filter
      if (this.selectedFilter.searchStartMonth) {
        this.filteredItems = this.filteredItems.filter(item => {
          if (item.firstPostDate) {
            let firstPostDate = utils.func.parseDate(item.firstPostDate)
            if (firstPostDate >= this.selectedFilter.searchStartMonth) return true
          }
          return false
        })
      }
      // end month filter
      if (this.selectedFilter.searchLastMonth) {
        this.filteredItems = this.filteredItems.filter(item => {
          if (item.lastPostDate) {
            let lastPostDate = utils.func.parseDate(item.lastPostDate)
            if (lastPostDate <= this.selectedFilter.searchLastMonth) return true
          }
          return false
        })
      }
      // HTML Report Filter
      if (this.selectedFilter.htmlReport) {
        let rptCampaignIDs = this.reports.map(rpt => rpt.campaignID)
        this.filteredItems = this.filteredItems.filter(item => {
          if (rptCampaignIDs.includes(item.id)) {
            return true
          }
          return false
        })
      }
    },
    pairingSearchFilter() {
      this.pairedFilterItems = this.pairedInfluencers.map(i => i)
      if (this.pairedFilter.payoutStatus) {
        this.pairedFilterItems = this.pairedFilterItems.filter(item => parseInt(item.payoutStatus) === parseInt(this.pairedFilter.payoutStatus))
      }
    },
    createCampaign(campaignData) {
      this.paginate(1);
    },
    clearSelectedCampaigns() {
      this.selectedCampaigns = []
      this.selectedCampaignIds = []
    },
    deleteCampaign(campaignID) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the campaign?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return campaignAPIs
            .deleteCampaign(campaignID)
            .then(response => {
              return response;
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.items = this.items.filter(campaign => campaign.id !== campaignID);

          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The campaign has been deleted successfully',
            type: 'success'
          });
        } else {
          // Do nothing for now
        }
      });
    },
    deleteBulkCampaigns(campaignIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaigns will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .deleteBulkCampaigns(campaignIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in deleting Campaign, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.paginate(1);
        } else {
          // Do nothing for now
        }
      });
    },
    async archiveCampaign(campaignIds) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = campaignIds.map(campaignID => {
            return Object.assign({}, {
              id: campaignID,
              archive: true
            })
          })
          // Submit request to save archived campaign data
          await this.$store.dispatch('campaign/updateCampaignByIds', data)
          this.isLoading = false;
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Archiving Campaigns.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Archived.',
            type: 'success'
          });
          this.paginate(1);
        }
      })
    },
    async getPairedInfluencers(campaign) {
      const campaignResp = await campaignAPIs.getCampaign(campaign.id)
      if (campaignResp) {
        this.campaignCOEB = Object.assign(
          {},
          {
            id: campaignResp.id,
            campaignId: campaignResp.id,
            campaignName: campaignResp.name,
            campaignType: campaignResp.campaignType,
            companyID: campaignResp.companyID,
            clientID: campaignResp.clientID,
            ioNumbers: campaignResp.ioNumbers,
            campaignOutreach: campaignResp.outreach,
            campaignEngagement: campaignResp.engagement,
            campaignBudget: campaignResp.budget,
            max_content: campaignResp.max_content,
            min_content: campaignResp.min_content,
            outreach: campaignResp.outreach,
            engagement: campaignResp.engagement,
            budget: campaignResp.budget
          }
        )
      }
      const pairingResp = await pairingAPIs.getPairedInfluencersByCampaign(campaign.id)
      if (pairingResp) {
        let items = [];
        for (let data of pairingResp) {
          let inf = this.beautifyData(data);
          // if (inf.eliminationStatus === campaignConfig.eliminationStatus.SELECTED) {
          //   items.push(inf);
          // }
          if (inf.pairingStatus === campaignConfig.pairingStatus.ACCEPTED) {
            items.push(inf);
          }
        }
        this.pairedInfluencers = Object.assign([], items);
        this.campaignMeasurement(items)
        /**
         * #NOTE
         * filter invited influencer list
         */
        const invitedItems = items
        .filter(e => e.pairingStatus !== campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementInvited(invitedItems)

        /**
         * #NOTE
         * filter not invited influencer list
         */
        const notInvitedItems = items
        .filter(e => e.pairingStatus === campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementNotInvited(notInvitedItems)
        if (this.isNotClientRole) {
          // this.clearPairingFilters()
          this.pairingSearchFilter()
          this.viewInfluencerAdminDialog = true;
        } else {
          this.viewInfluencerDialog = true;
        }
      }
    },
    campaignMeasurement(items) {
      // console.log('Campaign Outreach', this.campaignCOEB.outreach)
      this.measurement.total = 0
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(item => {
        this.measurement.total += Number(this.calculateContents(item))
        this.measurement.outreach += Number(this.calculateOutreach(item));
        this.measurement.engagement += Number(this.calculateEngagement(item));
        this.measurement.budget += Number(item.payout || 0);
      })
      let content = (this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaignCOEB.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaignCOEB.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.budget) * 100).toFixed(2);
    },
    campaignMeasurementInvited(items) {
      this.measurement.invitedTotal = 0
      items.map(item => {
        this.measurement.invitedTotal += Number(this.calculateContents(item))
        this.measurement.invitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.invitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.invitedBudget += Number(item.payout || 0);
      })
    },
    campaignMeasurementNotInvited(items) {
      this.measurement.notInvitedTotal = 0
      items.map(item => {
        this.measurement.notInvitedTotal += Number(this.calculateContents(item))
        this.measurement.notInvitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.notInvitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.notInvitedBudget += Number(item.payout || 0);
      })
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement(item) {
      const engagement = item.engagement;
      return (engagement || 0) * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = utils.func.refreshJSON(influencerDetails)
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = campaignHelper.getDeliverableDetails(deliverablesDetails)
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? reverse(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === campaignConfig.payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true
        }
        if (inf.payoutStatus >= campaignConfig.payoutStatus.CONFIRMED) {
          inf.payoutVerified = true
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details
      }
      return inf;
    },
    getCampaignDataToEdit(campaignID) {
      this.editCampaignId = campaignID;
      this.editModalDialog = true;
    },
    changeSettings(item) {
      this.viewCampaignData = item;
      this.campaignSettingsDialog = !this.campaignSettingsDialog;
    },
    viewCampaignByClient(campaignID) {
      if (this.campaignStatus === config.campaignStatus.PENDING_CLIENT_APPROVAL) {
        // show Terms
        this.$swal({
          title: campaignConfig.campaignConfirmation.termsAndCondition.title,
          html: campaignConfig.campaignConfirmation.termsAndCondition.html,
          type: 'info',
          width: 500,
          backdrop: `rgba(0,0,1, 0.9)`,
          showCancelButton: true,
          confirmButtonText: campaignConfig.campaignConfirmation.termsAndCondition.confirmButtonText,
          cancelButtonText: campaignConfig.campaignConfirmation.termsAndCondition.cancelButtonText,
          allowOutsideClick: false
        }).then(result => {
          if (!result.value) {
            this.viewModalDialog = false;
          } else {
            this.getCampaignDataToView(campaignID);
          }
        });
      } else {
        this.getCampaignDataToView(campaignID);
      }
    },
    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = Object.assign({}, response);
          this.viewModalDialog = true;
        })
        .catch(error => {
          // Request failed.
          this.viewModalDialog = false;
          console.log('error', error);
        });
    },
    viewInfluencerPairingModal(campaignData) {
      this.viewPairingCampaignData = Object.assign({}, campaignData);
      if (campaignData.clientID) {
        this.campaignClient = this.allClients.find(client => client.id === campaignData.clientID)
      }
      if (!this.$route.query.payoutConfirm) {
        this.$router.push({
          path: window.location.pathname,
          query: {
            campaignID: this.viewPairingCampaignData.id,
            pairing: true
          }
        })
        this.viewPairingModalDialog = true;
      } else {
        this.viewPairingModalDialog = true;
      }
    },
    openBrandSheetModalDialog(campaign) {
      let data = this.brandSheets.find(b => b.campaignID === campaign.id)
      data.clientName = this.getClientName(campaign.clientID);
      this.viewbrandSheetData = Object.assign({}, data)
      this.viewBrandSheetModalDialog = true
    },
    getPostDataToView(campaignData) {
      this.viewPostCampaignData = campaignData;
    },
    async showAMCCInputsDialog(campaignID) {
      this.amCCInputsDialog = true
      let campaign = await campaignAPIs.getCampaign(campaignID)
      this.campaignDataForRelease = Object.assign({}, campaign)
      return
    },
    async activateCampaign(campaignID, status) {
      var campaignConfirmation = campaignConfig.campaignConfirmation.activation[status];
      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Change only click yes
          campaignAPIs
            .updateCampaignActivationStatus(campaignID, status)
            .then(response => {
              // Refresh campaign list
              let campaign = response.campaign;
              campaign.campaignStatusDisplay = config.campaignStatusDisplay[campaign.status].display;
              campaign.updatedAtDisplay = this.formatTime(campaign.updatedAt);
              campaign.clientName = this.getClientName(campaign.clientID);
              this.editCampaign(campaign);
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);
            });
        } else {
          // Do Nothing
        }
      });
    },
    async releaseToAdmin(campaignID) {
      if (this.campaignStatus === config.campaignStatus.PENDING_CLIENT_APPROVAL) {
        let campaign = await campaignAPIs.getCampaign(campaignID)
        this.campaignDataForAccept = Object.assign({}, campaign);
        this.releaseToAdminDialog = true
        return
      }
    },
    async approveCampaign(campaignID) {
      // check for Release to CC
      if (this.campaignStatus === config.campaignStatus.DRAFT) {
        let campaign = await campaignAPIs.getCampaign(campaignID)
        this.campaignDataForSubmitDraft = Object.assign({}, campaign);
        this.releaseToCCDialog = true
        return
      }
    },
    async proceedReleaseToAdmin(campaignID) {
      // send email to Admin
    },
    async proceedApproveCampaign(campaignID) {
      // Get campaign confirmation configuration
      var campaignConfirmation = campaignConfig.campaignConfirmation.approval[this.campaignStatus];
      var sweetAlertOptions = {
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
          .approveCampaign(campaignID, this.campaignStatus)
          .then(response => {
            campaignAPIs
            .getCampaign(campaignID)
            .then(response => {
              if (response.status === config.campaignStatus.PAIRING_INFLUENCER) {
                this.viewCampaignData = Object.assign({}, response);
                this.prepareForPDF()
                this.doc = campaignPDF.convertPDFLayout(this.campaignModelSections, this.viewCampaignData, this.showBudget, this.copyrightText)
                campaignPDF
                .generatePDF(this.doc)
                .then(pdfData => {
                  this.sendEmail(campaignID, pdfData);
                })
                .catch(error => {
                  console.log('error in converting PDF', error);
                });
              }
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);
            });

            return response;
          })
          .catch(error => {
            // Request failed.
            console.log('error', error);
            // Show error message
            this.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }
      // Check Campaign Status and added required paramerters for the popup
      if (this.campaignStatus === config.campaignStatus.PENDING_CLIENT_APPROVAL) {
        sweetAlertOptions.html = campaignConfirmation['confirmation']['html'];
        sweetAlertOptions.input = campaignConfirmation['confirmation']['input'];
        sweetAlertOptions.inputValue = 0;
        sweetAlertOptions.inputPlaceholder = 'I have read and agree to the Terms and Conditions';
        sweetAlertOptions.showCancelButton = false;
        sweetAlertOptions.inputValidator = result => {
          return !result && 'You need to agree with T&C';
        };
        sweetAlertOptions.width = 850;
      }
      // Display confirmation box
      this.$swal(sweetAlertOptions).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(1);
          // Delete local data for the new status list to force refresh
          store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          });
          // Show success message
          this.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {
          // Do nothing for now
        }
      });
    },
    pushReviewCampaign(campaignID) {
      // push to review campaign
      this.invoicesBriefViewDialog = true
      setTimeout(() => {
        this.viewCampaignId = campaignID
      }, 100)
    },
    sendEmail(campaignID, pdfData) {
      campaignAPIs
        .sendCampaignPDF(campaignID, pdfData)
        .then(response => {
          return response;
        })
        .catch(error => {
          console.log('error in sending email with pdf attached', error);
        });
    },
    acceptInvite(pairingID) {
      campaignAPIs
        .acceptInvite(pairingID)
        .then(response => {
          // Refresh campaign list
          this.paginate(1);

          // Delete local data for the new status list to force refresh
          store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          });
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    rejectInvite(pairingID) {
      campaignAPIs
        .acceptInvite(pairingID)
        .then(response => {
          // Refresh campaign list
          this.paginate(1);

          // Delete local data for the new status list to force refresh
          store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          });
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    editCampaign(campaignData) {
      // Update the edited content to user
      var selectedIndex = -1;

      this.items.forEach(function (campaign, index) {
        if (campaign.id === campaignData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, campaignData);
      }

      // Do anything like highlighting the edited item
      this.paginate(1);
    },
    formatTime(value) {
      return moment(value).fromNow();
    },
    getClientName(id) {
      let result = null;
      this.allClients.forEach(item => {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name
          } else {
            result = item.name
          }
        }
      });
      return result;
    },
    eliminationStatusDisplay(id) {
      if (id === 0) {
        return 'Pending'
      } else if (id === 1) {
        return 'Selected'
      } else {
        return 'Eliminated'
      }
    },
    eliminatinStatusColor(id) {
      if (id === 0) {
        return 'primary'
      } else if (id === 1) {
        return '#8BC34A'
      } else {
        return 'red'
      }
    },
    payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return ''
      } else if (status === this.payoutStatus.INCOMPLETE || status === this.payoutStatus.SUBMITTED) {
        return 'warning'
      } else {
        return 'green'
      }
    },
    campaignPayoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '#2196f3'
      } else if (status === this.payoutStatus.CONFIRMED) {
        return '#4CAF50'
      } else return '#2196f3'
    },
    prepareForPDF() {
      this.showBudget = this.viewCampaignData.settings ? this.viewCampaignData.settings.showBudgetToClient : this.viewCampaignData.showBudgetToClient;
      this.showVideoBrief = this.viewCampaignData.settings ? this.viewCampaignData.settings.enableVideoBrief : this.viewCampaignData.enableVideoBrief;
      this.showEventBrief = this.viewCampaignData.settings ? this.viewCampaignData.settings.enableEventBrief : this.viewCampaignData.enableEventBrief;

      // remove Video Brief section if it is null
      if (!this.showVideoBrief) {
        let array = this.campaignModelSections.filter(sections => sections.type !== campaignConfig.campaignModelSectionType.VIDEO_BRIEF);
        this.campaignModelSections = array;
      }

      // remove Event Brief section if it is null
      if (!this.showEventBrief) {
        let array = this.campaignModelSections.filter(sections => sections.type !== campaignConfig.campaignModelSectionType.EVENT_BRIEF);
        this.campaignModelSections = array;
      }
      // delete budget label and values for clients view
      if (!this.showBudget && config.userRoles.CLIENT === this.currentUserRole) {
        let sections = this.campaignModelSections;
        let filteredContent;
        sections.forEach((section, index) => {
          if (section.type === this.campaignModelSectionType.BUDGET_ALLOCATION) {
            filteredContent = section.content.filter(field => field.name !== 'budget');
            this.campaignModelSections[index].content = filteredContent;
          }
        });
        delete this.campaignData.budget;
      }
    },
    openConfirmPayoutDialog(item) {
      this.influencer = Object.assign({}, item)
      this.payoutConfirmData = item
      this.invoiceDownload = false
      this.payoutConfirmDialog = true
    },
    setConfirmedPayout(item) {
      this.pairedInfluencers = this.pairedInfluencers.map(p => {
        if (p.pairingID === item.pairingID) {
          p.payoutAmount = item.payout || 0
          p.payout = item.payout || 0
          p.history = item.history
          p.payoutStatus = item.payoutStatus
          if (p.payoutSubmitted) {
            delete p.payoutSubmitted
          }
          if (!p.payoutVerified) {
            p.payoutVerified = true
          }
        }
        return p
      })
      this.reload()
    },
    getStageName(status) {
      if (status === this.campaignStatuses.DRAFT || status === this.campaignStatuses.PENDING_CLIENT_APPROVAL) {
        return this.campaignStage.ACTIVATING
      } else if (status === this.campaignStatuses.PAIRING_BRIEF || status === this.campaignStatuses.PAIRING_INFLUENCER || status === this.campaignStatuses.RATE_CARD) {
        return this.campaignStage.PAIRING
      } else if (status === this.campaignStatuses.ONGOING) {
        return this.campaignStage.COCREATING
      } else if (status === this.campaignStatuses.REVIEW) {
        return this.campaignStage.REVIEW
      } else {
        return this.campaignStage.COMPLETE
      }
    },
    formatDecimal(value) {
      return parseFloat(value).toFixed(2)
    },
    downloadCampaignDetailsReport(exportType) {
      this.loadingDialogOpen()
      let campaignIDs = this.filteredItems.map(i => i.id)
      campaignAPIs
        .downloadCampaignDetailsReport(campaignIDs, exportType)
        .then((response) => {
          this.loadingDialogClose()
          if (exportType === 'sync') {
            this.$swal({
              text: 'Started Syncing Creator Statistics Report.',
              type: 'success'
            });
          }
        })
        .catch(error => {
          this.loadingDialogClose()
          console.log('error in downloading all campaigns report', error);
        });
    },
    downloadAllCampaignsReport(exportType) {
      this.loadingDialogOpen()
      let exportItems = this.filteredItems.map(item => {
        item.createdDate = utils.func.formatCustomDate(item.createdAt, 'DD/MM/YYYY')
        if (item.activity) {
          const activity = item.activity
          item.briefAcceptedAt = activity.clientApproveAt ? utils.func.formatCustomDate(activity.clientApproveAt, 'DD/MM/YYYY') : ''
        }
        return item
      })
      campaignAPIs
        .downloadAllCampaignsReport(exportItems, exportType)
        .then(() => {
          this.loadingDialogClose()
          if (exportType === 'sync') {
            this.$swal({
              text: 'Started Syncing Cost & Period Report.',
              type: 'success'
            });
          }
        })
        .catch(error => {
          this.loadingDialogClose()
          console.log('error in downloading all campaigns report', error);
        });
    },
    async downloadCampaignPairingsReport(exportType) {
      this.loadingDialogOpen()
      // let filter = {
      //   status: campaignConfig.pairingStatus.ACCEPTED
      // }
      // let pairings = await pairingAPIs.getAllPairings(filter)
      // let campaignIDs = this.filteredItems.map(f => f.id)
      // pairings = pairings.filter(p => campaignIDs.includes(p.campaignID))
      // // pairings = pairings.map(item => {
      // //   item = this.beautifyExportData(item)
      // //   return item
      // // })
      // pairings = orderBy(pairings, ['id'], ['asc'])
      // pairings = pairings.map(p => p.id)
      // let infIds = pairings.map(p => p.influencerID).filter(infID => infID)
      // await this.$store.dispatch('influencer/getInfluencerByIds', {
      //   filters: {
      //     searchIds: infIds
      //   }
      // })
      let campaignIDs = this.filteredItems.map(i => i.id)
      pairingAPIs
        .downloadCampaignPairingsReport(campaignIDs, exportType)
        .then(() => {
          if (exportType === 'sync') {
            this.$swal({
              text: 'Started Syncing Creator Payout Report.',
              type: 'success'
            });
          }
          this.loadingDialogClose()
        })
        .catch(error => {
          this.loadingDialogClose()
          console.log('error in downloading all campaigns report', error);
        });
    },
    async downloadSystemPerformanceReport(exportType) {
      this.loadingDialogOpen()
      campaignAPIs
        .downloadSystemPerformanceReport(exportType)
        .then(() => {
          this.loadingDialogClose()
          if (exportType === 'sync') {
            this.$swal({
              text: 'Started Syncing Campaign Performance Report.',
              type: 'success'
            });
          }
        })
        .catch(error => {
          this.loadingDialogClose()
          console.log('error in downloading system performance report', error);
        });
    },
    async updateSend(item) {
      // check influencer on report
      const payload = this.getRptOwnerCheckPayload(item)
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      // confirm payout
      let confirmPayoutBlock = campaignConfig.campaignConfirmation.confirmPayout
      let message = confirmPayoutBlock.htmlAOK
      this.$swal({
        title: confirmPayoutBlock.title,
        html: message,
        confirmButtonText: confirmPayoutBlock.confirmButtonText,
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          await pairingAPIs.confirmAdminPayoutOnly(item.id)
          this.loadInfluencerData()
          // this.invoiceDownload = true
          // await this.preparedViewItem(item, -1)
          // this.invoiceDialog = true
        }
      });
    },
    async cancelPayout(item) {
      // check influencer on report
      // const payload = this.getRptOwnerCheckPayload(item)
      // await campaignHelper.invokeReportOwnerCheck(this, payload)
      let cancelPayoutBlock = campaignConfig.campaignConfirmation.cancelPayout
      let message = cancelPayoutBlock.html
      this.$swal({
        title: cancelPayoutBlock.title,
        html: message,
        confirmButtonText: cancelPayoutBlock.confirmButtonText,
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.loadingDialog = true
          await pairingAPIs.cancelAdminPayout(item.id)
          this.loadInfluencerData();
        }
      });
    },
    preparedViewItem(item, type) {
      // Get Influencer user profile only if have InfluencerID
      if (item.influencerID) {
        this.getUserByInfluencer(item.influencerID)
      }
      this.influencer = Object.assign({}, item)
      // ---------- if HTML data, get content HTML ----------
      if (item.brief_details && item.brief_details.contentHTML !== undefined) {
        this.briefDetailsHTML = item.brief_details.contentHTML
        // if not invoice download, select detail view tab
        this.selectedTab = type
        return;
      }
      let oldData = false
      if (item.brief_details && item.brief_details.content !== '' && item.brief_details.content.length > 0) {
        this.briefDetailContent.blocks = item.brief_details.content
        oldData = true
      } else {
        // this.br2iefDetailContent = ''
        this.briefDetailContent.blocks = campaignHelper.generateBlocks(item)
      }
      let blocksTohtml = new BlocksToHtml(this.briefDetailContent.blocks)
      this.briefDetailsHTML = blocksTohtml.generate(oldData)
      // if not invoice download, select detail view tab
      this.selectedTab = type
    },
    getUserByInfluencer(id) {
      // console.log('influencerID', id)
      let param = {
        'influencerID': id
      }
      userAPIs.getUserByInfluencer(param)
      .then(res => {
        // console.log('Response user by influencerID', res)
        this.influencerProfile = res
      })
    },
    resetFilter() {
      this.selectedFilter = {
        campaignType: '',
        vertical: '',
        targetLocation: '',
        AM: '',
        CO: '',
        client: '',
        stage: 'All'
      }
      this.filter = ''
      this.searchFilter()
    },
    closeModal() {
      this.dialog = false;
    },
    loadingDialogOpen() {
      this.loadingDialog = true
    },
    loadingDialogClose() {
      this.loadingDialog = false
    },
    loadInfluencerData() {
      this.getPairedInfluencers(this.campaignCOEB)
      this.loadingDialog = false;
      // this.loading = true;
      // this.prepareDataTable().then(data => {
      //   this.influencerList = data.items;
      //   this.totalInfluencer = data.total;
      //   this.loading = false;
      //   // this.dialog = false;
      //   this.loadingDialog = false;
      // });
    },
    linkPayoutInternal(item) {
      window.open(`/campaignPayoutsInternal?influencerID=${item.influencer_details.influencerID}&campaignID=${item.CampaignID}&verified=true`, '_blank')
    },
    getSubmittedCount(item) {
      return this.payoutSubmittedPairings.filter(p => p.campaignID === item.id).length
    },
    getRptOwnerCheckPayload(item) {
      return Object.assign({}, {
        campaignID: item.CampaignID,
        handle: item.instagramHandle,
        platform: item.platform
      })
    },
    clearPairingFilters() {
      this.pairedFilter = {
        payoutStatus: '',
        search: ''
      }
    },
    selectAllCampaigns($event) {
      if (($event.value && $event.items.length === 0) || !$event.value) {
        this.selectedCampaigns = [];
        return;
      }
      if (this.selectedCampaigns.length === 0) {
        this.selectedCampaigns = $event.items
      } else this.selectedCampaigns = []
    },
    performSelected(action) {
      let ids = this.selectedCampaigns.map(item => item.id);
      switch (action) {
        case 'changeStatus':
          this.changeBulkStatus(ids);
          break;
        case 'deleteCampaign':
          this.deleteBulkCampaigns(ids);
          break;
        case 'archiveCampaign':
          this.archiveCampaign(ids)
          break;
      }
    },
    changeBulkStatus(ids) {
      this.selectedCampaignIds = ids
      this.campaignDataForStatusChange = this.selectedCampaigns[0]
      this.changeStatusDialog = true;
    },
    restoreArchive() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = this.selectedCampaigns.map(item => {
            return Object.assign({}, {
              id: item.id,
              archive: false
            })
          })
          // Submit request to restore archived report data
          await this.$store.dispatch('campaign/updateCampaignByIds', data)
          this.isLoading = false;
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Restoring Campaigns.',
              type: 'error'
            });
            return
          }
          this.selectedCampaigns = []
          // Show success message
          this.$swal({
            text: 'Successfully restored.',
            type: 'success'
          });
          this.paginate(1)
        }
      })
    },
    formatCampaignVerticals(campaign) {
      let selectedCampaignVertical = []
      if (campaign.vertical) {
        this.campaignVerticals.map(item => {
          campaign.vertical.map(vertical => {
            if (item.id === vertical) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    getCountryDisplayValueFromSelect: function(value) {
      if (typeof value === 'string') return value
      var selectedOption = this.countries.filter(option => {
        return value.includes(option.code)
      });
      return selectedOption ? selectedOption.map(o => o.name).join(', ') : '-';
    },
    beautifyExportData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      const campaign = this.filteredItems.find(f => f.id === data.campaignID)
      inf = data.influencer_details;
      inf.influencer_details = utils.func.refreshJSON(influencerDetails)
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.campaignName = campaign ? campaign.name : ''
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate ? influencerDetails.engagement_rate + '%' : 0;
      inf.deliverables = campaignHelper.getDeliverableDetails(deliverablesDetails)
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
      }
      if (data.pairing_details) {
        inf.submission_date = data.pairing_details.submission_date ? utils.func.formatCustomDate(data.pairing_details.submission_date, 'DD/MM/YYYY') : ''
      }
      return inf;
    },
    searchStartMonthOk() {
      this.$refs.startMonthPicker.save(this.selectedFilter.searchStartMonth);
      this.searchFilter()
    },
    searchEndMonthOk() {
      this.$refs.endMonthPicker.save(this.selectedFilter.searchLastMonth);
      this.searchFilter()
    },
    checkShowURLParam() {
      this.isUnlockCogs = false
      if (this.$route.query.campaignID && (this.$route.query.payoutConfirm || this.$route.query.pairing)) {
        let campaign = this.items.find(item => item.id === this.$route.query.campaignID)
        this.viewInfluencerPairingModal(campaign)
      } else if (this.$route.query.campaignID && this.$route.query.unlockCogs) {
        let campaign = this.items.find(item => item.id === this.$route.query.campaignID)
        this.isUnlockCogs = true
        this.viewInfluencerPairingModal(campaign)
      } else if (this.$route.query.campaignID) {
        this.getCampaignDataToView(this.$route.query.campaignID)
      }
    },
    openReportPasscodeDialog(type, exportType) {
      this.exportType = exportType
      this.downloadReportType = type
      this.allReportsPasscodeDialog = true
    },
    reportPasscodeSuccess() {
      if (this.downloadReportType === 'details') {
        this.downloadCampaignDetailsReport(this.exportType)
      } else if (this.downloadReportType === 'all') {
        this.downloadAllCampaignsReport(this.exportType)
      } else if (this.downloadReportType === 'pairings') {
        this.downloadCampaignPairingsReport(this.exportType)
      } else if (this.downloadReportType === 'performance') {
        this.downloadSystemPerformanceReport(this.exportType)
      }
    },
    getReportsByCampaignIDs(campaigns) {
      let campaignIDs = campaigns.map(c => c.id)
      this.$store.dispatch('campaign/getReportsByCampaignIDs', campaignIDs)
    },
    showCheckListDialog(campaign) {
      // implement checklists
      this.campaignDataForRelease = Object.assign({}, campaign)
      this.briefReleaseChecklistDialog = true
    },
    proceedActivateCampaign(campaignID) {
      // invoke to activate campaign
      this.activateCampaign(campaignID, this.campaignActivationStatusConfig.ACTIVATED)
    },
    formatMonth(date) {
      if (!date) return '';
      return moment(date).format('MMM YYYY');
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.allCampaignHeaders.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.allCampaignHeaders)) {
        if (value.text && value.value !== 'action') {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.allCampaignCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    getCountries() {
      // Retrieve countries manually
      this.countries = countries
      this.countries = this.countries.map(c => c)
      this.countries.unshift({
        name: 'All Countries',
        code: ''
      })
      // influencerAPIs.getCountries().then(countries => {
      //   this.countries = countries.map(item => item.name);
      // });
    },
    setUnlockCogs(status) {
      this.isUnlockCogs = status
    },
    directClient(campaignID) {
      this.$swal({
        title: 'Direct Release Client',
        text: 'Are you sure you want to direct release client?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Change only click yes
          campaignAPIs
            .updateCampaignDirectRelease(campaignID)
            .then(response => {
              // Refresh campaign list
              if (!response.success) {
                this.$swal({
                  text: 'Error Direct Release to Client.',
                  type: 'error'
                });
                return
              }
              // Show success message
              this.$swal({
                text: 'Successfully direct released to client.',
                type: 'success'
              });
              this.paginate(1)
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);
            });
        } else {
          // Do Nothing
        }
      });
    }
  },
  async mounted() {
    // get Client Lists
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER ||
      this.currentUserRole === config.userRoles.FINANCE
    ) {
      try {
        let response = await clientAPIs.getAllClients(false)
        this.allClients = response.data;
        this.allClients.unshift({id: '', name: 'All Clients'})
        // Get all AM by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        if (response) {
          this.AM = response.users
          this.AM = this.AM.map(am => {
            am.name = `${am.firstName} ${am.lastName}`
            return am
          })
        }
        this.AM.unshift({id: '', name: 'All Team'})
        // Get all CO by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
        if (response) {
          this.CO = response.users
          this.CO = this.CO.map(co => {
            co.name = `${co.firstName} ${co.lastName}`
            return co
          })
          this.CO.unshift({id: '', name: 'All Team'})
        }
        // Get all brand sheet lists
        campaignAPIs
        .getAllBrandSheets()
        .then(response => {
          // Refresh campaign list
          if (response.success) {
            this.brandSheets = response.data
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });

        // Get all countries
        // await this.$store.dispatch('campaign/getCountries')
        this.getCountries()
        // Get all campaign verticals and unshift for filter
        let vResp = await campaignAPIs.getAllCampaignVerticals(false)
        this.campaignVerticals = vResp.data
        this.campaignVerticals.unshift({id: -1, name: 'Empty Verticals'})
        this.campaignVerticals.unshift({id: '', name: 'All Verticals'})
        // type filters
        this.campaignTypeDisplayFilter = utils.func.refreshJSON(this.campaignTypeDisplayFilter)
        this.campaignTypeDisplayFilter.unshift({value: -1, text: 'Empty Types'})
        this.campaignTypeDisplayFilter.unshift({value: '', text: 'All Types'})
        // this.targetLocationDisplayFilter.unshift({value: '', text: 'All Locations'})
        this.payoutSubmittedPairings = await pairingAPIs.getAllPayoutSubmittedPairings()
        if (this.$route.query.verified) {
          this.selectedFilter.verified = 'Verified Payouts'
        }
      } catch (error) {
        // Request failed.
        console.log('error', error);
      }
    }

    // if (this.currentUserRole === config.userRoles.CLIENT) {
    //   this.checkForVendorFormComplete();
    // }
    this.getUserProfile()
    this.paginate(1);
  }
};
</script>
<style>
  .bulk-action .v-toolbar__content {
    padding-left: 0;
  }

</style>
<style scoped>
  .paired-actions-cell {
    min-width: 120px;
    max-width: 160px;
  }

  .paired-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .paired-action-btn {
    margin: 0 !important;
  }

  .filter-checkbox {
    max-width: 150px;
  }
  .filter-checkbox .v-label {
    font-weight: 500!important;
  }
</style>



// WEBPACK FOOTER //
// index.vue?099a616f